import { z } from 'zod'
import type { ZodIssueLike } from './errorText'
import { zodIssueText } from './errorText'

/**
 * Makes zod's messages follow the panel's language (client-side forms,
 * `zodResolver`): the same `validation.*` texts as a refused input from the
 * server. An issue the catalog has no text for gets zod's own English one,
 * and a message a schema sets itself (`z.string().min(1, '…')`) wins as in
 * zod. Call once, where the app starts.
 */
export function installZodMessages(): void {
  const english = z.locales.en().localeError
  z.config({
    localeError: (issue) => {
      const fallback = english(issue)
      const text = typeof fallback === 'string' ? fallback : fallback?.message
      return zodIssueText(issue as ZodIssueLike, text ?? 'Invalid input')
    },
  })
}
